import React from "react";
import ProtectedRoute from "./ProtectedRoute";
import WhatsAppSetupGate from "./whatsapp/WhatsAppSetupGate";

/**
 * Protected WhatsApp page — permission check then tenant Meta setup gate.
 */
export default function WhatsAppRoute({ children, ...protectedRouteProps }) {
  return (
    <ProtectedRoute {...protectedRouteProps}>
      <WhatsAppSetupGate>{children}</WhatsAppSetupGate>
    </ProtectedRoute>
  );
}
